import { action, computed, observable, decorate } from 'mobx'

import { Model, PREFERRED_COMMUNICATION_TYPES, REQUEST_TYPES } from '../models/form.model'

import { emailRegex } from '../utils/validateInput'

export class Form implements Model {
    requestType = REQUEST_TYPES.NONE;
    namePrefix = '';
    nameFirst = '';
    nameMiddle = '';
    nameLast = '';
    nameSuffix = '';
    contactEmail = '';
    contactPhone = '';
    addressLine1 = '';
    addressLine2 = '';
    addressCity = '';
    addressState = '';
    addressZIP = '';
    contactBy = PREFERRED_COMMUNICATION_TYPES.NONE;
    acceptDisclaimer = false;

    firstStepComplete = () => {
      return this.requestType !== REQUEST_TYPES.NONE;
    }
    secondStepComplete = () => {
      return !!(this.nameFirst && this.nameLast);
    }
    thirdStepComplete = () => {
      const contactBySelected = this.contactBy !== PREFERRED_COMMUNICATION_TYPES.NONE
      const emailOK = this.contactEmail && emailRegex.test(this.contactEmail)
      const phoneOK = this.contactPhone && this.contactPhone.length === 12
      return !!(contactBySelected && emailOK && phoneOK);
    }
    fourthStepComplete = () => {
      const streetAddressOK = this.addressLine1 && this.addressLine1.length >= 5;
      const cityStateOK = this.addressCity && this.addressState !== ''
      const zipOK = this.addressZIP && (this.addressZIP.length === 5 || this.addressZIP.length === 10)
      return !!(streetAddressOK && cityStateOK && zipOK)
    }
    fifthStepComplete = () => {
      return !!this.acceptDisclaimer;
    }

    constructor(model?: Model) {
        this.updateForm(model)
    }

    get currentStep() {
      switch (false) {
        case this.firstStepComplete():
          return 0
        case this.secondStepComplete():
          return 1
        case this.thirdStepComplete():
          return 2
        case this.fourthStepComplete():
          return 3
        case this.fifthStepComplete():
          return 4
        default:
          return 5
      }
    }

    updateForm = (model?: object) => {
        if (model) {
            Object.assign(this, model)
        }
    }
}

decorate(Form, {
  requestType: observable,
  namePrefix: observable,
  nameFirst: observable,
  nameMiddle: observable,
  nameLast: observable,
  nameSuffix: observable,
  contactEmail: observable,
  contactPhone: observable,
  addressLine1: observable,
  addressLine2: observable,
  addressCity: observable,
  addressState: observable,
  addressZIP: observable,
  contactBy: observable,
  acceptDisclaimer: observable,

  currentStep: computed,
  updateForm: action.bound
})